<template>
  <div class="p-4 flex justify-between bg-white z-10 w-full">
<!--    <span class="rounded-lg p-1 border border-gray-200 hover:bg-gray-50 duration-200 cursor-pointer relative" @click="showConfig = true" v-click-outside="hideConfig">
      <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6 text-gray-500 hover:text-gray-700" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
        <path stroke-linecap="round" stroke-linejoin="round" d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z" />
        <path stroke-linecap="round" stroke-linejoin="round" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
      </svg>
    </span>-->
    <span></span>

    <span class="rounded-lg p-1 border border-gray-200 hover:bg-gray-50 duration-200 cursor-pointer relative" @click="showDropdown = true" v-click-outside="hideDropdown">
      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="h-6 w-6 text-gray-500 hover:text-gray-700">
        <path stroke-linecap="round" stroke-linejoin="round" d="M11.42 15.17L17.25 21A2.652 2.652 0 0021 17.25l-5.877-5.877M11.42 15.17l2.496-3.03c.317-.384.74-.626 1.208-.766M11.42 15.17l-4.655 5.653a2.548 2.548 0 11-3.586-3.586l6.837-5.63m5.108-.233c.55-.164 1.163-.188 1.743-.14a4.5 4.5 0 004.486-6.336l-3.276 3.277a3.004 3.004 0 01-2.25-2.25l3.276-3.276a4.5 4.5 0 00-6.336 4.486c.091 1.076-.071 2.264-.904 2.95l-.102.085m-1.745 1.437L5.909 7.5H4.5L2.25 3.75l1.5-1.5L7.5 4.5v1.409l4.26 4.26m-1.745 1.437l1.745-1.437m6.615 8.206L15.75 15.75M4.867 19.125h.008v.008h-.008v-.008z" />
      </svg>

      <transition
        enter-class="mt-2 opacity-0"
        leave-class="mt-0 opacity-100"
        enter-to-class="mt-0 opacity-100"
        leave-to-class="mt-2 opacity-0"
      >
        <div v-if="showDropdown" class="absolute duration-200 bottom-full left-full mt-2 w-56 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 divide-y divide-gray-100 focus:outline-none" role="menu" aria-orientation="vertical" aria-labelledby="menu-button" tabindex="-1">
          <div class="py-1" role="none">
            <span class="text-gray-700 group flex items-center px-4 py-2 text-sm" role="menuitem" tabindex="-1" id="menu-item-4" @click="importTemplate">
              <svg xmlns="http://www.w3.org/2000/svg" class="mr-3 h-5 w-5 text-gray-400 group-hover:text-gray-500" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                <path stroke-linecap="round" stroke-linejoin="round" d="M12 10v6m0 0l-3-3m3 3l3-3m2 8H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
              </svg>
              Import template
            </span>
            <span class="text-gray-700 group flex items-center px-4 py-2 text-sm" role="menuitem" tabindex="-1" id="menu-item-5" @click="createCustomTemplate">
              <svg xmlns="http://www.w3.org/2000/svg" class="mr-3 h-5 w-5 text-gray-400 group-hover:text-gray-500" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                <path stroke-linecap="round" stroke-linejoin="round" d="M4 5a1 1 0 011-1h14a1 1 0 011 1v2a1 1 0 01-1 1H5a1 1 0 01-1-1V5zM4 13a1 1 0 011-1h6a1 1 0 011 1v6a1 1 0 01-1 1H5a1 1 0 01-1-1v-6zM16 13a1 1 0 011-1h2a1 1 0 011 1v6a1 1 0 01-1 1h-2a1 1 0 01-1-1v-6z" />
              </svg>
              Create template
            </span>
          </div>
          <div class="py-1" role="none">
            <span class="text-gray-700 group flex items-center px-4 py-2 text-sm" role="menuitem" tabindex="-1" id="menu-item-6" @click="resetAllChanges">
              <svg xmlns="http://www.w3.org/2000/svg" class="mr-3 h-5 w-5 text-gray-400 group-hover:text-gray-500" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                <path stroke-linecap="round" stroke-linejoin="round" d="M18.364 18.364A9 9 0 005.636 5.636m12.728 12.728A9 9 0 015.636 5.636m12.728 12.728L5.636 5.636" />
              </svg>
              Reset all config changes
            </span>
            <span class="text-gray-700 group flex items-center px-4 py-2 text-sm" role="menuitem" tabindex="-1" id="menu-item-6" @click="startFromScratch">
              <svg xmlns="http://www.w3.org/2000/svg" class="mr-3 h-5 w-5 text-gray-400 group-hover:text-gray-500" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                <path stroke-linecap="round" stroke-linejoin="round" d="M9 13h6m-3-3v6m-9 1V7a2 2 0 012-2h6l2 2h6a2 2 0 012 2v8a2 2 0 01-2 2H5a2 2 0 01-2-2z" />
              </svg>
              Start from scratch
            </span>
          </div>
        </div>
      </transition>
    </span>

    <portal to="root">
      <TemplatesManagerModal v-model="showingTemplateManager"
                        @trigger-default-template="createCustomTemplate"
                        @edit-template="editTemplate"
                        @close-manager="closeAll"

                        ref="templates-manager"
      />
      <CreateCustomTemplate v-model="showingNewTemplateForm"
                            :editing="editing"
                            @close-manager="closeAll"

                            @refetch-templates="refetchTemplates"
      />
    </portal>
  </div>
</template>

<script>

import TemplatesManagerModal from "@/components/SideEditor/TemplatesManager/TemplatesManagerModal.vue"
import CreateCustomTemplate from "@/components/SideEditor/TemplatesManager/CreateCustomTemplate.vue"

export default {
  props: ['triggerTemplateImport'],
  components: {
    TemplatesManagerModal,
    CreateCustomTemplate,
  },
  data() {
    return {
      showConfig: false,
      showingTemplateManager: false,
      showDropdown: false,
      showingNewTemplateForm: false,

      editing: null,
    }
  },
  methods: {
    startFromScratch() {
      this.$store.commit("editor/startingFromScratch", true)
      this.$store.commit("editor/nonRecursiveConfig", {})
      this.$store.commit("editor/restart")
      this.$emit("reseted-all-changes")
    },
    editTemplate({ template, editorPackage }) {
      this.editing = { template, editorPackage }
      this.showingNewTemplateForm = true
    },
    closeAll() {
      this.showingTemplateManager = false
      this.showingNewTemplateForm = false
    },
    async createCustomTemplate() {
      this.showingTemplateManager = true
      this.showingNewTemplateForm = true
    },
    importTemplate() {
      this.showingTemplateManager = true
    },
    refetchTemplates() {
      this.$refs["templates-manager"].reload()
    },

    resetAllChanges() {
      this.$store.commit("editor/resetAllConfigChanges")
      this.$emit("reseted-all-changes")
    },
    hideConfig() {
      this.showConfig = false
    },
    hideDropdown() {
      this.showDropdown = false
    },
  },
  watch: {
    triggerTemplateImport() {
      this.importTemplate()
    },
    showingNewTemplateForm(val) {
      if (!val) this.editing = null
    },
  },
}

</script>
